import { QueryClient } from "@tanstack/react-query";

const isLocalDev = process.env.NODE_ENV === "development";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: isLocalDev ? 0 : 30 * 1000,
      gcTime: isLocalDev ? 0 : 5 * 60 * 1000,
      refetchOnWindowFocus: isLocalDev,
    },
  },
});
